var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8442",
    "data-name": "Group 8442",
    transform: "translate(-771 -376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9137",
    "data-name": "Path 9137",
    d: "M0,0H24V24H0Z",
    transform: "translate(771 376)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9138",
    "data-name": "Path 9138",
    d: "M16,9V19H8V9h8M14.5,3h-5l-1,1H5V6H19V4H15.5ZM18,7H6V19a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2Z",
    transform: "translate(771 376)",
    fill: "rgba(224,40,6,0.84)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.61f8234a628d613369618b479ca7c38b.svg";
export { ForwardRef as ReactComponent };